import type { NavigationEntry } from '@shared/navigation-sidebar';

/**
 * Navigation de BackStage, au format attendu par `app-navigation-sidebar`.
 *
 * Remplace la configuration maison qui vivait dans `app.component.ts`. Les
 * libelles sont des CLES transloco : la barre du kit les passe systematiquement
 * par le pipe, elles sont donc definies dans `assets/i18n/fr.json`.
 *
 * Les icones sont restreintes a `NavIconType`, le sous-ensemble du registre que
 * le modele de navigation autorise — d'ou quelques choix differents des anciens
 * glyphes (`ticket`, `download`, `layers` et `edit` n'en font pas partie).
 */
export const NAVIGATION_BACKSTAGE: readonly NavigationEntry[] = [
  {
    kind: 'item',
    id: 'clients',
    label: 'navigation.clients',
    icon: 'users',
    route: '/clients/liste-clients',
  },
  {
    kind: 'section',
    id: 'redditions',
    label: 'navigation.redditions',
    icon: 'receipt',
    children: [
      { id: 'evenements', label: 'navigation.evenements', icon: 'calendar-check', route: '/redditions/evenements' },
      { id: 'formules', label: 'navigation.formules', icon: 'calendar', route: '/redditions/formules' },
      { id: 'fichier-sap', label: 'navigation.fichierSap', icon: 'folder', route: '/redditions/fichier-sap' },
    ],
  },
  {
    kind: 'section',
    id: 'rapprochements',
    label: 'navigation.rapprochements',
    icon: 'blocks',
    children: [
      {
        id: 'rapprochement-manuel',
        label: 'navigation.rapprochementManuel',
        icon: 'sliders',
        route: '/rapprochement/rapprochement-manuel',
      },
    ],
  },
  {
    kind: 'section',
    id: 'parametrage',
    label: 'navigation.parametrage',
    icon: 'settings',
    children: [
      { id: 'commissions', label: 'navigation.commissions', icon: 'receipt', route: '/parametrage/commissions' },
    ],
  },
];
